import { Component, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';

import { ContatoForma, CONTATOS_FORMAS, isContatoFormaTelefone, isContatoFormaEmail, isContatoFormaWhatsApp, isContatoFormaLinkedInMessaging, isContatoFormaFacebookMessenger, isContatoFormaInstagramDirectMessenger, isContatoFormaTelegram, isContatoFormaVideoconferencia, isContatoFormaContatoSite, isContatoFormaOutra } from '../../contato-forma';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

interface Config {
    isTelefone: boolean;
    isEmail: boolean;
    isWhatsApp: boolean;
    isLinkedInMessaging: boolean;
    isFacebookMessenger: boolean;
    isInstagramDirectMessenger: boolean;
    isTelegram: boolean;
    isVideoconferencia: boolean;
    isContatoSite: boolean;
    isOutra: boolean;
    isValid?: boolean;
}

@Component({
    selector: 'sgt-contato-forma-select',
    templateUrl: './contato-forma-select.component.html',
    styleUrls: ['./contato-forma-select.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ContatoFormaSelectComponent), multi: true },
    ]
})
export class ContatoFormaSelectComponent implements OnInit {
    config: Config;

    /** formas de contas */
    formasOptions = CONTATOS_FORMAS;

     /** forma do contato */
     @Input() ngModel: number;
     /** Ao alterar a forma do contato */
     @Output() ngModelChange = new EventEmitter<number>();

    /** Forma de contato selecionada */
    forma: ContatoForma;
    /** Forma de conato alterada */
    @Output() formaChange = new EventEmitter<ContatoForma>();

    /** Nome do input */
    @Input() name: string;
    /* ID do input */
    @Input() id: string;
    /** Se deve desabilitar o input */
    @Input() disabled: boolean;
    /** Se a forma de contato é obrigatória */
    @Input() required = false;

    @ViewChild('dropdownToggle') dropdownToggle: ElementRef;

    propagateChange: any = () => {};

    ngOnInit(): void {
        this.forma = this.formasOptions.find(formaFilter => formaFilter.id == this.ngModel);
        this.setConfig();
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'ngModel' && !changes[propName].isFirstChange()) {
                this.forma = this.getForma(this.ngModel);
                this.setIsValid();
            } else if (propName === 'required') {
                this.setIsValid();
            }
        }
    }

    /** Obtem a forma através do ID */
    private getForma(id: number): ContatoForma {
        if (!id || !this.formasOptions) {
            return null;
        }
        return this.formasOptions.find(formaFilter => formaFilter.id === id);
    }

    /** Ao selecionar a forma de contato */
    onChange(forma: ContatoForma) {
        this.ngModel = forma ? forma.id : null;
        this.ngModelChange.emit(this.ngModel);
        this.propagateChange(this.ngModel);

        this.forma = forma;
        this.formaChange.emit(this.forma)

        this.setConfig();
    }

    /** Seta as configs. do select */
    private setConfig() {
        this.config = {
            isTelefone: isContatoFormaTelefone(this.ngModel),
            isEmail: isContatoFormaEmail(this.ngModel),
            isWhatsApp: isContatoFormaWhatsApp(this.ngModel),
            isLinkedInMessaging: isContatoFormaLinkedInMessaging(this.ngModel),
            isFacebookMessenger: isContatoFormaFacebookMessenger(this.ngModel),
            isInstagramDirectMessenger: isContatoFormaInstagramDirectMessenger(this.ngModel),
            isTelegram: isContatoFormaTelegram(this.ngModel),
            isVideoconferencia: isContatoFormaVideoconferencia(this.ngModel),
            isContatoSite: isContatoFormaContatoSite(this.ngModel),
            isOutra: isContatoFormaOutra(this.ngModel),
        }
        this.setIsValid();
    }

    private setIsValid() {
        if (!this.config) {
            return;
        }

        // Obrigatório e não selecionada a forma de contato
        if (this.required && !this.ngModel) {
            this.config.isValid = false;
            return;
        }

        this.config.isValid = true;
    }

    get isValid(): boolean {
        return this.config.isValid;
    }

    /** Seta foco no select */
    setFocus() {
        jQuery(this.dropdownToggle?.nativeElement).trigger('focus');
    }

    writeValue(value: number) {}

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
